export default __webpack_public_path__ + "static/pintura_automocion-eb55449ffe496a3c8ab101b966869dd3.png";